export const FORM_TYPE = {
  SIGNIN: "SignIn",
  SIGNUP: "SignUp",
};

export const LOGO =
  "https://cdn.cookielaw.org/logos/dd6b162f-1a32-456a-9cfe-897231c7763c/4345ea78-053c-46d2-b11e-09adaef973dc/Netflix_Logo_PMS.png";

export const USER_AVATAR =
  "https://occ-0-6247-2164.1.nflxso.net/dnm/api/v6/K6hjPJd6cR6FpVELC5Pd6ovHRSk/AAAABdpkabKqQAxyWzo6QW_ZnPz1IZLqlmNfK-t4L1VIeV1DY00JhLo_LMVFp936keDxj-V5UELAVJrU--iUUY2MaDxQSSO-0qw.png?r=e6e";

export const PHOTO_URL = ""
  // "https://media.licdn.com/dms/image/v2/D4D03AQHfTV6WRiYTtw/profile-displayphoto-shrink_100_100/profile-displayphoto-shrink_100_100/0/1689400286128?e=1734566400&v=beta&t=98ui9OWf_WAgvPiTU3qU97b6AAESp4veNO1d61kyeFA";

export const MOVIE_OPTIONS = {
  method: "GET",
  headers: {
    accept: "application/json",
    Authorization:
      "Bearer_TOKEM",
  },
};

export const IMG_CDN = "https://image.tmdb.org/t/p/w500/";
export const EMPTY_ARRAY = [];
export const EMPTY_STRING = "";

export const LANGUAGE_PLACEHOLDER = {
  English: {
    searchText: "Search",
    placeholder: "What Would You Like To Watch Today eg:Funny-movies",
  },
  Hindi: { searchText: "खोज", placeholder: "आज आप क्या देखना चाहेंगे" },
  German: {
    searchText: "buscar",
    placeholder: "Was möchtest du heute sehen?",
  },
  Spanish: { searchText: "suchen", placeholder: "¿Qué te gustaría ver hoy?" },
};

export const GEMINI_API_KEY = "AIzaSyBLxAtsTjHDmNa5m38qkqQtlU8CP6GbLgE";

